import { memo } from 'react'
import styled from 'styled-components'
import { getWineContacts } from 'utils/wine'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`

const Contacts = styled.div`
  font-weight: 500;
  font-size: 10px;
  line-height: 140%;
  color: #121432;
  padding-top: 5px;
`

const ContactLine = styled.div``

const filterAndJoin = arr => arr.filter(Boolean).join(' | ')

const Left = ({ wine }) => {
  const contacts = getWineContacts(wine)
  const line1 = filterAndJoin([contacts.tradeName, contacts.website])
  const line2 = filterAndJoin([contacts.email, contacts.phone])

  return (
    <Wrapper>
      <Contacts>
        <ContactLine>{line1}</ContactLine>
        <ContactLine>{line2}</ContactLine>
      </Contacts>
    </Wrapper>
  )
}

export default memo(Left)
